import parseArcaResponse from '../parseArcaResponse';

/**
 * Aviso NO bloqueante del backend: la aportación se ha ejecutado, pero sumando
 * las mensuales que quedan por cobrarse este año el usuario se pasaría del tope.
 */
export type OneTimeContributionWarning = 'ANNUAL_LIMIT_EXCEEDED_WITH_SCHEDULED_CONTRIBUTIONS';

export interface CreateOneTimeContributionResponse {
	success: boolean;
	data?: {
		amount: number;
		/** Margen de tope anual que le queda tras esta aportación. */
		remainingAfter: number;
		warning: OneTimeContributionWarning | null;
	};
}

/**
 * Aportación PUNTUAL (única) al plan PERSONAL del usuario autenticado, adicional
 * a su aportación periódica mensual. Vale para individuales y autónomos, tengan
 * empresa o no: lo que manda es el plan, no la situación laboral.
 *
 * `planCatalogId` es el plan que el usuario tiene delante en pantalla. Con varios
 * planes personales el backend lo EXIGE (`PLAN_CATALOG_ID_REQUIRED`): no elige por
 * su cuenta, que es como una aportación acaba en el plan equivocado. Se omite del
 * body cuando no se ha resuelto (`plan_catalog_id` es nullable hasta el backfill):
 * mandarlo vacío haría que el backend buscase un plan inexistente.
 *
 * Cuando el backend rechaza, `parseArcaResponse` lanza con el CÓDIGO
 * (`ANNUAL_CONTRIBUTION_LIMIT_EXCEEDED`, `ONE_TIME_CONTRIBUTION_ALREADY_MADE_TODAY`…);
 * traducirlo a un mensaje para el usuario es cosa de `translateOneTimeContributionError`.
 */
const createOneTimeContribution = async (
	token: string,
	amount: number,
	planCatalogId?: string
): Promise<CreateOneTimeContributionResponse> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/one-time-contribution`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(planCatalogId ? { amount, planCatalogId } : { amount })
	});

	return parseArcaResponse<CreateOneTimeContributionResponse>(response);
};

export default createOneTimeContribution;
